var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"montserrat-font"},[_c('header-view'),_c('mape-introduction'),_c('about-us'),_c('unique-view'),_c('quantum-leap'),_c('platform-details'),_c('contact-us'),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }